module.exports = __webpack_public_path__ + "static/media/book-reader.5c167054.svg";